import React from 'react';
import {render} from 'react-dom';

import {BestRates} from '../finance/widgets/best-rates/best-rates';

const frontEndWidget = document.getElementById('best-rates');

if (frontEndWidget) {
  render(<BestRates />, frontEndWidget);
}
